import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from "./FixedContainer.module.scss";

/**
 * Responsive container that can be fixed to top or bottom at specific breakpoints
 * Stays in normal document flow on larger screens
 */
const FixedContainer = ({ variant, letterCase, ...props }) => {
    const { 
        children, 
        fixedOn = 'md',
        position = 'bottom',
        className = '',
        //title = '',
    } = props;

    const [isMobile, setIsMobile] = useState(false);

    // Validate fixedOn is a valid Bootstrap breakpoint
    const validBreakpoints = ['sm', 'md', 'lg', 'xl', 'xxl', 'always'];
    const validFixedOn = validBreakpoints.includes(fixedOn) ? fixedOn : 'md';
    
    // Validate position is either 'top' or 'bottom'
    const validPositions = ['top', 'bottom'];
    const validPosition = validPositions.includes(position) ? position : 'bottom';

    // Determine if container should be fixed based on screen width
    useEffect(() => {
        // Function to check if we should switch to fixed mode based on breakpoint
        const checkBreakpoint = () => {
            if (validFixedOn === 'always') {
                setIsMobile(true);
                return;
            }

            // Bootstrap breakpoint values in pixels
            const breakpoints = {
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
                xxl: 1400
            };

            // Get the breakpoint value or default to md
            const breakpointValue = breakpoints[validFixedOn] || breakpoints.md;
            
            // Check if window width is below the breakpoint
            setIsMobile(window.innerWidth < breakpointValue);
        };

        // Initial check
        checkBreakpoint();

        // Add resize listener
        window.addEventListener('resize', checkBreakpoint);
        
        // Cleanup
        return () => {
            window.removeEventListener('resize', checkBreakpoint);
        };
    }, [validFixedOn]);
    
    return (
        <div className={`
            ${styles.FixedContainer}
            ${isMobile ? styles.fixed : ''}
            ${isMobile ? `fixed-${validPosition}` : ''}
            ${isMobile ? 'shadow-lg' : ''}
            ${isMobile ? 'vw-100' : ''}
            ${className}
        `}>
            {/* {title && (
                <span className="fs-6 mb-2 text-center">
                    {title}
                </span>
            )} */}
            
            <div className={`
                d-flex
                flex-row 
                justify-content-around 
                w-100 
                ${styles.gap}
                ${styles.children}
            `}>
                {children}
            </div>
        </div>
    );
};

FixedContainer.propTypes = {
    children: PropTypes.node,
    fixedOn: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl', 'always']),
    position: PropTypes.oneOf(['top', 'bottom']),
    className: PropTypes.string, 
    title: PropTypes.string,
};

export default FixedContainer;